import { Component, ChangeDetectionStrategy, ViewEncapsulation, HostBinding } from '@angular/core'

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SpinnerComponent {
  @HostBinding('class') class = 'spinner-loader'
}
